import { links } from "settings";
import { calculateSiteResolutionIndependent, decodeSiteResolutionValue } from "shared/mechanics/site-resolution";

import { AuthButtons } from './Buttons';

import styles from './Modal.module.scss';
import logo_prem from 'shared/images/logo-investor-plus.png';
import { AuthService } from "shared/mechanics/auth";
import { AnalyticGoals, AnalyticsService } from "shared/mechanics/analytics";

const authLink = `/auth/signin?redirectUrl=${encodeURI(document.location.pathname + document.location.search)}`;
const userInfo = AuthService.resolveUserInfo();

export interface AuthModalProps {
	title: string;
	showAdvantages: boolean;
	onClose: () => void;
}
export const AuthModal = (props: AuthModalProps) => {
	const siteResolution = calculateSiteResolutionIndependent();

	const resolutionClass = decodeSiteResolutionValue(siteResolution, styles.desktop, styles.compact);

	return (
		<div className={styles.wrapper}>
			<div className={`${styles.container} ${resolutionClass}`}>
				{
					userInfo == null
						? (
							<div className={`${styles.buttons} ${resolutionClass}`}>
								<h2 className={styles.title}>Погрузись в <br/>рынок биржевых фондов</h2>
								<p className={styles.text}>и присоединись к 3 000 пассивных инвесторов!</ p>
								<AuthButtons />
								<p className={styles.text}>Проблемы со входом? <a href={authLink} className={styles.a_signin}>Альтернативный вход</a></p>
								<p className={styles.text_under}><small>При использовании rusetfs.com необходимо соблюдать <a href={links.footer.termsOfUse}>пользовательское соглашение</a> и принять <a href="https://blog.rusetfs.com/posts/%D0%BF%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0-%D0%BA%D0%BE%D0%BD%D1%84%D0%B8%D0%B4%D0%B5%D0%BD%D1%86%D0%B8%D0%B0%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8">политику конфиденциальности</a>.</small></p>
							</div>
						)
						: null
				}
				{
					props.showAdvantages
						? (
								<div className={`${styles.description} ${resolutionClass}`}>
									<p className={styles.text}>{props.title}</p>

									<p className={styles.title}>ИНВЕСТОР<img src={logo_prem} alt="Премиум " className={styles.lofogem}/></p>
									<div className={styles.containerprem}>
											<ul className={styles.ulbenefitslist}>
												<li className={styles.libenefitslist}>Без рекламы</li>
												<li className={styles.libenefitslist}>Данные в USD и EUR</li>
												<li className={styles.libenefitslist}>Полный состав фондов</li>
											</ul>

											<a className={styles.action} href='/subscription/select' onClick={() => AnalyticsService.onGoalReached(AnalyticGoals.SUBSCRIPTION_MODAL_OPENED)}>
												Подробнее
											</a>
									</div>

								</div>
						)
						: null
				}
			</div>
			<div className={styles.button_close}>
				<i className="far fa-window-close" onClick={() => props.onClose()}></i>
			</div>
		</div>
	);
}
